/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AboutDialogComponent } from './about-dialog.component';
import { DxButtonModule, DxTemplateModule } from 'devextreme-angular';
import { SysqueFrameModule } from 'libs/sysque/shared/ui/src/lib/components/sysque-frame';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [{ path: 'dialog/about-dialog', component: AboutDialogComponent }];

@NgModule({
  declarations: [AboutDialogComponent],
  imports: [CommonModule, DxTemplateModule, DxButtonModule, SysqueFrameModule, RouterModule.forChild(routes)],
  exports: [AboutDialogComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AboutDialogModule {}
